var ctrl = function($scope) {
  $scope.offsetStart = $scope.pagination.perPage * ($scope.pagination.page - 1) + 1;
  $scope.offsetEnd = $scope.pagination.perPage * $scope.pagination.page;

  var goToPage = function(n) {
    $scope.pagination.goToPage(n);
    if ($scope.onNavigation) {
      $scope.onNavigation();
    }
  };
  if ($scope.offsetEnd > $scope.pagination.totalEntries) {
    $scope.offsetEnd = $scope.pagination.totalEntries;
  }

  $scope.nextPage = function() {
    if (!$scope.hasNextPage()) { return; }
    var newPage = $scope.pagination.page + 1;
    goToPage(newPage);
  };

  $scope.hasNextPage = function() {
    return ($scope.offsetStart + $scope.pagination.perPage) <=
      $scope.pagination.totalEntries;
  };

  $scope.previousPage = function() {
    if (!$scope.hasPreviousPage()) { return; }
    var newPage = $scope.pagination.page - 1;
    goToPage(newPage);
  };

  $scope.hasPreviousPage = function() {
    return $scope.pagination.page > 1;
  };

  $scope.pageNumbers = function() {
    var startPage = $scope.pagination.page - 2;
    if (startPage < 1) { startPage = 1; }

    var endPage = startPage + 5;
    var lastPage = Math.ceil($scope.pagination.totalEntries / $scope.pagination.perPage);

    if (endPage > lastPage) { endPage = lastPage; }

    var res = [];
    for (var i = startPage; i <= endPage; i++) {
      res.push(i);
    }
    return res;
  };
};

ctrl.$inject = ['$scope'];

tiz.controller('PaginationFullCtrl', ctrl);

var directive = function() {
  return {
    controller: 'PaginationFullCtrl',
    templateUrl: require('../../templates/pagination/full.html'),
    scope: {
      pagination: '=',
      onNavigation: '&'
    }
  };
};

tiz.directive('paginationFull', directive);
